export default [
  {
    path: '/call-centre/rejected-statistics',
    name: 'pageRejectedStatistics',
    meta: { title: 'page.pageRejectedStatistics' },
    component: () => import('@/pages/call-centre/rejected-statistics/index.vue'),
  },
]
